import styled from "styles/styled_components";

interface IStyledOptionProps {
  isSelected: boolean;
  isExpanded: boolean;
}

export const Option = styled("li")<IStyledOptionProps>`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.brandWhite};
  border-radius: ${props => props.theme.borderRadius};
  cursor: pointer;
  flex-direction: row;
  height: ${props => `calc(4 * ${props.theme.gridBase})`};
  justify-content: space-between;
  padding: ${props =>
    `${props.theme.gridBase} calc(2 * ${props.theme.gridBase})`};

  :hover {
    background-color: ${props =>
      props.isExpanded ? props.theme.colors.brandBlue10 : ""};
  }
`;

export const Label = styled.span`
  flex: 1;
  align-items: center;
`;

export const Block = styled.span`
  width: 15px;
`;
